import React, { useState } from 'react';
import { TextField, Grid, Typography, Divider } from '@mui/material';

const PlaycheckComponent = ({ selectedServer }) => {
  // State variables equivalent to Vue's data properties
  const [orionUsername, setOrionUsername] = useState("");
  const [orionPassword, setOrionPassword] = useState("");
  const [sessionId, setSessionId] = useState(null);
  const [transactionId, setTransactionId] = useState(null);

  // Computed helper methods
  const sessionIdLink = sessionId && sessionId !== 0 ? `&sessionid=${sessionId}` : "";
  const transactionIdLink = transactionId && transactionId !== 0 ? `&transactionid=${transactionId}` : "";

  const getSiteId = (siteName) => {
    const map = {
      njs: 67, mis: 67, pas: 67, ons: 67, cts: 67,
      njp: 71, mip: 82, pap: 75, ctp: 91,
      onp: 96,
    };
    return map[siteName?.toLowerCase()] || '';
  };
  const siteId = getSiteId(selectedServer?.site?.name);
  const getShortLanguage = () => 'en';

  // Link Generation
  const playcheckPlayer = `https://redirector${siteId}.gamedistribute.com/playcheck/Default.aspx?applicationid=1001&serverid=${selectedServer?.serverId}&usertoken=${selectedServer?.authToken}${sessionIdLink}${transactionIdLink}&lang=${getShortLanguage()}`;
  //https://playcheck82.gamedistribute.com/playcheck/default.aspx?accounttype=&adminuser=&appmode=&clienttypeid=40&fbusername=&hidelogin=&password=&serverid=37255&ssologintype=0&tokentype=&ul=en&userid=&username=defaultTestssdf&usertoken=&usertype=0&transactionid=&timezone=&sessionid=&launchtoken=&accesstoken=
 
 
  const playcheckOperator = `https://redirector${siteId}.gamedistribute.com/playcheck/Default.aspx?applicationid=1001&serverid=${selectedServer?.serverId}&username=${selectedServer?.token}&appmode=OperatorPlayCheckView&adminuser=${orionUsername}&password=${orionPassword}${sessionIdLink}${transactionIdLink}&lang=${selectedServer?.language?.shortCode}`;

  const playcheckDerivco = `https://redirector${siteId}.gamedistribute.com/playcheck/Default.aspx?applicationid=1001&serverid=${selectedServer?.serverId}&username=${selectedServer?.token}&password=PTS_ADMIN${sessionIdLink}${transactionIdLink}&lang=${selectedServer?.language?.shortCode}`;

  // JSX Structure (Replacing Vue template)
  return (
    <div>
      <Grid container spacing={3}>
        {/* Player Playcheck */}
        <Grid item xs={12}>
          {/* <Typography>Player Playcheck</Typography> */}
          <TextField
            fullWidth
            variant="outlined"
            value={playcheckPlayer}
            label="Player Playcheck"
            helperText="Launch link for player playcheck"
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>

        {/* Operator Playcheck */}
        <Grid item xs={12}>
          {/* <Typography>Operator Playcheck</Typography> */}
          <TextField
            fullWidth
            variant="outlined"
            value={playcheckOperator}
            label="Operator Playcheck"
            helperText="Launch link for operator playcheck"
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>

        {/* Divider */}
        <Grid item xs={12}>
          <Divider />
        </Grid>

        {/* Derivco Playcheck */}
        <Grid item xs={12}>
          {/* <Typography>Derivco Playcheck</Typography> */}
          <TextField
            fullWidth
            variant="outlined"
            value={playcheckDerivco}
            label="Derivco Playcheck"
            helperText="Super user link for playcheck, do not send to operators!"
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>
      </Grid>

      {/* Additional Fields */}
      <Grid container spacing={3} style={{ marginTop: '16px' }}>
        {/* Orion Username */}
        <Grid item md={3}>
          <Typography>Orion Username</Typography>
          <TextField
            fullWidth
            variant="outlined"
            value={orionUsername}
            onChange={(e) => setOrionUsername(e.target.value)}
            placeholder="Type the operator's Orion username"
            helperText="Username for Orion"
          />
        </Grid>

        {/* Orion Password */}
        <Grid item md={3}>
          <Typography>Orion Password</Typography>
          <TextField
            fullWidth
            variant="outlined"
            value={orionPassword}
            onChange={(e) => setOrionPassword(e.target.value)}
            placeholder="Type the operator's Orion password"
            helperText="Password for Orion"
          />
        </Grid>

        {/* Session ID */}
        <Grid item md={3}>
          <Typography>Session ID</Typography>
          <TextField
            fullWidth
            variant="outlined"
            value={sessionId || ""}
            onChange={(e) => setSessionId(e.target.value)}
            placeholder="Type a session ID here"
            helperText="Identifier of specific session"
          />
        </Grid>

        {/* Transaction ID */}
        <Grid item md={3}>
          <Typography>Transaction ID</Typography>
          <TextField
            fullWidth
            variant="outlined"
            value={transactionId || ""}
            onChange={(e) => setTransactionId(e.target.value)}
            placeholder="Type a transaction ID here"
            helperText="Identifier of specific transaction"
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default PlaycheckComponent;
